// @ts-nocheck
import * as React from 'react';
import axios from 'axios';
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import HelpIcon from "@mui/icons-material/Help";
import { URL_API_SIA } from "../Contantes/Constantes";
import { useBody } from "../Body/state/BodyContext";
import { useAuth } from "../Auth/State/AuthContext";
import Tooltip from "@mui/material/Tooltip";

export default function SOItem({ so, manual, icon, titulo, sx }) {
    const axiosInstance = setupInterceptorsTo(axios.create())
    const { setMessage, setLoadingBackdrop } = useBody();
    const { user } = useAuth();

    const descargarCertificado = () => {
        setLoadingBackdrop(true)
        axiosInstance({
            method: 'GET',
            url: `${URL_API_SIA}/instaladores/` + so + '/' + user.uid,
            responseType: 'blob',
        })
            .then((response) => {
                setLoadingBackdrop(false)
                const url = window.URL.createObjectURL(response.data);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = so === 'linux' ? 'Instalador-VPN-' + user.uid + '.ovpn' : 'Instalador-VPN-' + user.uid + '.exe';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((e) => {
                setLoadingBackdrop(false)
                setMessage("Hubo un error al querer descargar los certificados (Código de error : 00061)");
            })
    }

    return (
        <ListItemButton sx={sx}>
            <ListItemIcon>
                {icon}
            </ListItemIcon>
            <ListItemText primary={titulo} />
            <Tooltip title={'Descargar Certificado'}><IconButton onClick={descargarCertificado}><DownloadIcon color='primary' /></IconButton></Tooltip>
            <Tooltip title={'Ver manual de certificado'}><IconButton onClick={() => window.open(manual, '_blank', 'noopener,noreferrer')}><HelpIcon color='primary' /></IconButton></Tooltip>
        </ListItemButton>
    );
}